import { inject, Injectable, signal } from "@angular/core";
import { UserPreferencesModel } from "./user-preferences.model";
import { AuthService } from "../../core/services/auth/auth.service";
import { TaskStatus } from "../tasks/task.model";

@Injectable({ providedIn: 'root' })
export class UserPreferencesService {

  private auth = inject(AuthService);

  defaultUserPreferences = <UserPreferencesModel>{
    language: 'de',
    okrTreeColumns: ['team', 'progress', 'status', 'cycle'],
    okrTreeSortColumn: null,
    okrTreeSortDirection: 'asc',
    okrTreeColumnSizes: {},
    fileAttachmentsColumns: ['filename', 'created', 'category', 'description'],
    fileAttachmentsSortColumn: null,
    fileAttachmentsSortDirection: 'asc',
    fileAttachmentsColumnSizes: {},
    recentSearches: {},
    taskKanbanBoardColumns: <TaskStatus[]>['open', 'inProgress', 'done'],
    taskViews: [],
    helpPageAutostart: true,
  };

  private _userPreferences = signal<UserPreferencesModel>({
    ...this.defaultUserPreferences,
    ...JSON.parse(localStorage.getItem('user-prefs') || '{}'),
  });

  public userPreferences = this._userPreferences.asReadonly();

  updateUserPreferences(newPrefs: UserPreferencesModel) {
    this._userPreferences.set(newPrefs);

    localStorage.setItem('user-prefs', JSON.stringify(this.userPreferences()));
  }

  patch(overwrites: Partial<UserPreferencesModel>) {
    this._userPreferences.update(prefs => {
      if (!prefs) {
        return {...this.defaultUserPreferences, ...overwrites};
      }
      return {...prefs, ...overwrites};
    });
    localStorage.setItem('user-prefs', JSON.stringify(this.userPreferences()));
  }
}
